import axios from 'axios';
import { GET_OUT_OF_STOCK, OUT_OF_STOCK_LOADING } from './types';

export const getOutOfStockProducts = () => (dispatch: any) => {
  dispatch({ type: OUT_OF_STOCK_LOADING });
  axios
    .get('/api/admin/getOutOfStockProducts')
    .then((res) => dispatch({ type: GET_OUT_OF_STOCK, payload: res.data }))
    .catch((err) => console.log(err));
};
